// Copyright ©️ 2026 eVolve MEP, LLC

import { type TaskType, useEvolveDelete } from '@evolvemep/api-ts';
import { Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';

import type { ModalRegistryManagedProps } from 'components/Mantine/Modals/createModalRegistry';
import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';

type Props = ModalRegistryManagedProps & {
  taskType: TaskType;
  onTaskTypeDeleted: (taskType: TaskType) => void;
};

export const DeleteTaskTypeModal = ({ taskType, onTaskTypeDeleted, ...props }: Props) => {
  const { apiCall: deleteTaskTypeApiCall } = useEvolveDelete(`shop/taskType/${taskType.taskTypeId}`);
  return (
    <WrappedModal
      title="Delete task"
      confirmationText="Delete"
      onConfirm={async () => {
        await deleteTaskTypeApiCall();
        onTaskTypeDeleted(taskType);
        notifications.show({
          title: 'Successfully deleted task',
          message: `Task ${taskType.name} deleted.`,
          color: 'green',
        });
      }}
      {...props}
    >
      <Text>
        Are you sure you want to delete <b>{taskType.name}</b>?
      </Text>
      <Text>Deleting a task will remove it from every catalog assembly in which it appears.</Text>
    </WrappedModal>
  );
};
